export default {
  error: state => state.error,
  recurrencyError: state => state.recurrencyError,
  formLoading: state => state.formLoading,
  success: state => state.success,
  loading: state => state.loading,
  exportLoading: state => state.exportLoading,
  exportSuccess: state => state.exportSuccess,
  notice: state => state.notice,
  notices: state => state.notices,
  recurrency: state => state.recurrency,
  paging: state => state.paging,
  noticeCreated: state => state.noticeCreated,
  sendMail: state => state.sendMail,
  sendMailSuccess: state => state.sendMailSuccess,
  coownersFields: state => state.coownersFields,
  coownerUser: state => state.coownerUser,
  sendNoticeToUser: state => state.sendNoticeToUser,
  getNoticePlaceholder: state => state.getNoticePlaceholder,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/Notices/getters.js